import { StatusCodes } from '@e3dc-react/shell/Libs'
import { AuthFetchError } from '@e3dc-react/shell/Types/api'
import { ApiResult } from 'src/Libs/api'
import { handleFetchError } from 'src/Libs/api/utils'
import { AuthFetchWithResponse } from 'src/Types/api'

/*
 * Subscribes to the notifications service with the deviceAppToken and user id
 */
export const subscribeForPushNotifications = async (
  deviceAppToken: string,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<null, AuthFetchError | Error>> => {
  try {
    const response = await authFetch({
      path: `notifications/register`,
      method: 'POST',
      endpoint: process.env.REACT_APP_NOTIFICATION_ENDPOINT,
      payload: {
        deviceId: deviceAppToken,
      },
    })

    if (response.status === StatusCodes.CREATED) {
      return new ApiResult<null, AuthFetchError | Error>(null, false)
    }

    return new ApiResult<null, AuthFetchError | Error>(null, true)
  } catch (error) {
    return handleFetchError<null>(error)
  }
}

/*
 * Unsubscribes from the notifications service - the deviceAppToken connected to the user id will be removed
 */
export const unsubscribeFromPushNotifications = async (deviceAppToken: string, authFetch: AuthFetchWithResponse): Promise<ApiResult<void>> => {
  const response = await authFetch<void>({
    path: `notifications/register`,
    method: 'DELETE',
    endpoint: process.env.REACT_APP_NOTIFICATION_ENDPOINT,
    payload: {
      deviceId: deviceAppToken,
    },
  })

  if (response.status === StatusCodes.NO_CONTENT) {
    return new ApiResult<void>(null, false)
  }

  return new ApiResult<void>(null, true)
}
